import React from 'react'

import { Button, Col, Form, Row } from '_zari/core'

import { RounderUtil } from 'utils'

const ResumenMontosSection = ({
  detalles,
  dispatch,
  clickGuardar,
  vId,
  resetMainForm,
  onChangeCheckbox,
  checkedCheckbox,
  isSubmitting,
  setDiferenciaSoles,
  diferenciaSoles,
  resumenTotales = null
}) => {
  const updateStatus = React.useCallback(
    payload => {
      dispatch({ type: 'actualizar', payload: payload })
    },
    [dispatch]
  )

  const montosCalculados = React.useMemo(() => {
    if (resumenTotales) return null

    let debeSolesTotal = 0
    let haberSolesTotal = 0
    let debeExtranjeroTotal = 0
    let haberExtranjeroTotal = 0

    let flagMonedaUnicaDolares = detalles.every(x => x.moneda === 'DOLARES')

    if (detalles && detalles.length > 0) {
      for (let i = 0; i < detalles.length; i++) {
        let debeSoles = 0
        let haberSoles = 0
        let debeExtranjero = 0
        let haberExtranjero = 0

        const row = detalles[i]

        if (row.dh && (row.importeDebe || row.importeHaber) && row.moneda) {
          if (row.dh === 'DEB') {
            debeSoles = parseFloat(row.moneda === 'SOLES' ? row.importeDebe : row.importeDebeSecundario)
            debeExtranjero = parseFloat(row.moneda === 'SOLES' ? row.importeDebeSecundario : row.importeDebe)
          } else {
            haberSoles = parseFloat(row.moneda === 'SOLES' ? row.importeHaber : row.importeHaberSecundario)
            haberExtranjero = parseFloat(row.moneda === 'SOLES' ? row.importeHaberSecundario : row.importeHaber)
          }
        }

        debeSolesTotal = RounderUtil.roundTwoDecimals(debeSolesTotal + debeSoles)
        haberSolesTotal = RounderUtil.roundTwoDecimals(haberSolesTotal + haberSoles)
        debeExtranjeroTotal = RounderUtil.roundTwoDecimals(debeExtranjeroTotal + debeExtranjero)
        haberExtranjeroTotal = RounderUtil.roundTwoDecimals(haberExtranjeroTotal + haberExtranjero)
        if (
          i === detalles.length - 1 &&
          flagMonedaUnicaDolares &&
          RounderUtil.roundTwoDecimals(debeExtranjeroTotal - haberExtranjeroTotal) === 0 &&
          RounderUtil.roundTwoDecimals(debeSolesTotal - haberSolesTotal) !== 0
        ) {
          const diferenciaSolesv = RounderUtil.roundTwoDecimals(debeSolesTotal - haberSolesTotal)
          const detallesDebe = detalles.filter(x => x.dh === 'DEB')
          const ultimoDetalleDebe = detallesDebe[detallesDebe.length - 1]

          updateStatus({
            ...ultimoDetalleDebe,
            importeDebeSecundario: ultimoDetalleDebe.importeDebeSecundario - diferenciaSolesv
          })
          setDiferenciaSoles(0)
        }
      }
    }

    const salida = {
      debeSolesTotal: debeSolesTotal,
      haberSolesTotal: haberSolesTotal,
      debeExtranjeroTotal: debeExtranjeroTotal,
      haberExtranjeroTotal: haberExtranjeroTotal
    }

    setDiferenciaSoles(-Math.abs(RounderUtil.round(salida.debeSolesTotal - salida.haberSolesTotal)))

    return {
      ...salida,
      diferenciaSoles: -Math.abs(RounderUtil.round(salida.debeSolesTotal - salida.haberSolesTotal)),
      diferenciaExtranjero: -Math.abs(RounderUtil.round(salida.debeExtranjeroTotal - salida.haberExtranjeroTotal))
    }
  }, [detalles, setDiferenciaSoles, updateStatus, resumenTotales])

  const montos = React.useMemo(() => {
    if (resumenTotales) {
      const diferenciaSoles = -Math.abs(RounderUtil.round(resumenTotales.totalDebe - resumenTotales.totalHaber))
      const diferenciaExtranjero = -Math.abs(
        RounderUtil.round(resumenTotales.totalDebeExtranjero - resumenTotales.totalHaberExtranjero)
      )

      return {
        debeSolesTotal: resumenTotales.totalDebe,
        haberSolesTotal: resumenTotales.totalHaber,
        debeExtranjeroTotal: resumenTotales.totalDebeExtranjero,
        haberExtranjeroTotal: resumenTotales.totalHaberExtranjero,
        diferenciaSoles,
        diferenciaExtranjero
      }
    }
    return montosCalculados
  }, [resumenTotales, montosCalculados])

  const onSubmit = React.useCallback(() => {
    clickGuardar()
  }, [clickGuardar])

  const clickCancelar = React.useCallback(() => {
    resetMainForm({})
  }, [resetMainForm])

  return (
    <Row>
      <Col md={5}>
        <Row className='zari-slim-form'>
          <Col md={12}>
            <Row>
              <Col md={2} />
              <Col md={3}>
                <Form.Group>
                  <Form.Label text='DEBE' md={12} />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label text='HABER' md={12} />
                </Form.Group>
              </Col>
              {montos.diferenciaExtranjero || montos.diferenciaSoles ? (
                <Col md={4}>
                  <Row>
                    <Col md={7}>
                      <Form.Group>
                        <Form.Label text='DIFERENCIA' md={12} />
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              ) : null}
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label text='SOLES' md={12} alignRightAt='md' />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Col md={12}>
                    <Form.InputText
                      id='input-totaldebesoles'
                      name='input-totaldebesoles'
                      disabled
                      value={montos.debeSolesTotal}
                    />
                  </Col>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Col md={12}>
                    <Form.InputText
                      id='input-totalhabersoles'
                      name='input-totalhabersoles'
                      disabled
                      value={montos.haberSolesTotal}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {montos.diferenciaSoles ? (
                <Col md={4}>
                  <Row>
                    <Col md={12}>
                      <Form.Group>
                        <Col md={12}>
                          <Form.InputText
                            id='input-diferenciasoles'
                            name='input-diferenciasoles'
                            className='text-danger'
                            isInvalid
                            disabled
                            value={montos.diferenciaSoles}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              ) : null}
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label text='EXTRANJ' md={12} alignRightAt='md' />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Col md={12}>
                    <Form.InputText
                      id='input-totaldebeextranjero'
                      name='input-totaldebeextranjero'
                      disabled
                      value={montos.debeExtranjeroTotal}
                    />
                  </Col>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Col md={12}>
                    <Form.InputText
                      id='input-totalhaberextranjero'
                      name='input-totalhaberextranjero'
                      disabled
                      value={montos.haberExtranjeroTotal}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {montos.diferenciaExtranjero ? (
                <Col md={4}>
                  <Form.Group>
                    <Col md={12}>
                      <Form.InputText
                        id='input-diferenciaExtranjero'
                        name='input-diferenciaExtranjero'
                        className='text-danger'
                        isInvalid
                        disabled
                        value={montos.diferenciaExtranjero}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              ) : null}
            </Row>
          </Col>
        </Row>
      </Col>
      <Col md={7}>
        <Row>
          <Col md={5} className='text-right'>
            <Form.Checkbox
              id='checkbox-actualizarPlantilla'
              name='checkbox-actualizarPlantilla'
              label='Actualizar plantilla'
              onChange={onChangeCheckbox}
              checked={checkedCheckbox}
            />
          </Col>
          <Col md={7} className='text-right'>
            <Button color='secondary' onClick={clickCancelar}>
              Cancelar
            </Button>
            <Button onClick={onSubmit} disabled={isSubmitting}>
              Guardar
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default React.memo(ResumenMontosSection)
